var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', {
    staticClass: "search-list",
    attrs: {
      "title": _vm.title ? _vm.$t(_vm.title) : ''
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "outline-none",
    staticStyle: {
      "width": "90%",
      "margin-right": "40px"
    },
    attrs: {
      "tabindex": "0"
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$emit('search');
      }
    }
  }, [_vm._t("default")], 2), _c('div', {
    staticStyle: {
      "width": "10%",
      "padding-left": "20px"
    }
  }, [_c('LoadingButton', {
    attrs: {
      "className": "mt-3",
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('search');
      }
    }
  }, [_c('ez-icon', {
    staticStyle: {
      "margin-right": "3px"
    },
    attrs: {
      "icon": "ezAr-icon-search"
    }
  }), _vm._v(_vm._s(_vm.buttonText ? _vm.$t(_vm.buttonText) : _vm.$t("ar_common_search")))], 1)], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }